import { DateTime } from 'luxon';

import { PopupRangeParameters } from './popup-range-parameters';

export class PopupRangeStore
{
    /**
     * Date minimale acceptable
     */
    public minDate: DateTime = null;
    /**
     * Date maximale acceptable
     */
    public maxDate: DateTime = null;
    /**
     * Valeur initiale de Since, utilisée en cas de reset
     */
    public initSince: DateTime = null;
    /**
     * Valeur initiale de Until, utilisée en cas de reset
     */
    public initUntil: DateTime = null;
    /**
     * Since courant initialisé à rangeSince
     * modifié par le click sur le calendrier Since
     * Renvoyé par 'Apply'
     */
    private _currentSince: DateTime = null;
    get currentSince ()
    {
        return this._currentSince;
    }
    set currentSince (value: DateTime)
    {
        this._currentSince = value;
        this.firstDaySinceCalendar = value.startOf('month');
    }
    /**
     * Until courant initialisé à rangeUntil
     * modifié par le click sur le calendrier Until
     * Renvoyé par 'Apply'
     */
    private _currentUntil: DateTime = null;
    get currentUntil ()
    {
        return this._currentUntil;
    }
    set currentUntil (value: DateTime)
    {
        this._currentUntil = value;
        this.firstDayUntilCalendar = value.startOf('month');
    }
    /**
     * Premier & dernier jours du mois affiché de "SinceCalendar"
     */
    private _firstDaySinceCalendar: DateTime;
    get firstDaySinceCalendar ()
    {
        return this._firstDaySinceCalendar;
    }
    set firstDaySinceCalendar (value: DateTime)
    {
        this._firstDaySinceCalendar = value;
        this._lastDaySinceCalendar = this._firstDaySinceCalendar.endOf('month');
    }
    private _lastDaySinceCalendar: DateTime;
    get lastDaySinceCalendar ()
    {
        return this._lastDaySinceCalendar;
    }
    /**
     * Premier & derneir jours du mois affiché de "UntilCalendar"
     */
    private _firstDayUntilCalendar: DateTime;
    get firstDayUntilCalendar ()
    {
        return this._firstDayUntilCalendar;
    }
    set firstDayUntilCalendar (value)
    {
        this._firstDayUntilCalendar = value;
        this._lastDayUntilCalendar = this._firstDayUntilCalendar.endOf('month');
    }
    private _lastDayUntilCalendar: DateTime;
    get lastDayUntilCalendar ()
    {
        return this._lastDayUntilCalendar;
    }

    public static init (data: PopupRangeParameters): PopupRangeStore
    {
        const cfg = new PopupRangeStore();

        Object.assign(cfg, data);

        cfg.currentSince = cfg.initSince;
        // cfg.firstDaySinceCalendar = cfg.currentSince.startOf('month');

        cfg.currentUntil = cfg.initUntil;
        // cfg.firstDayUntilCalendar = cfg.currentUntil.startOf('month');

        return cfg;
    }
}
